import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/public/images/techtarget-logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBar"] */ "/opt/atlassian/pipelines/agent/build/src/components/SearchBar/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/UserNav/UserNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomOrgWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/customOrgContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/envContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/langContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceWrapper"] */ "/opt/atlassian/pipelines/agent/build/src/context/resourceContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/style/global.scss");
